import { TABLA_CAMIONES_ENTRE_PLAYA_CALADO } from '../../../../config/tables'
import TablaCamionesEntrePlayaCalado from '../../../../models/camiones/tabla_camiones_entre_playa_calado'
import { COLUMNS_CAMIONES_ENTRE_PLAYA_CALADO, COLUMNS_CAMIONES_ENTRE_PLAYA_CALADO_TO_PRINT } from './constantesCamionesEntrePlayaCalado'
import { pdfCustomToolbarGenerator } from '../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable (filtroInicial = null) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_ENTRE_PLAYA_CALADO
    })
    TablaCamionesEntrePlayaCalado.getDataCamionesEnTransito().then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, cartadeporte: d.numero }) })
      const customToolbar = pdfCustomToolbarGenerator(
        'Camiones entre playa y calado',
        data,
        COLUMNS_CAMIONES_ENTRE_PLAYA_CALADO_TO_PRINT,
        'landscape')

      const textRowCount = 'Cantidad de camiones: '

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_ENTRE_PLAYA_CALADO,
          data: data,
          title: `Camiones entre playa y calado`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '599px',
            showRowCount: true,
            textRowCount,
            filtroInicial: filtroInicial
          }
        },
        id: TABLA_CAMIONES_ENTRE_PLAYA_CALADO
      })
    }
  }
}
